import axios from "axios"


const axiosPeppol = axios.create({baseURL:"https://ibanity.hhinformatique.be",headers:{
    Authorization:"Bearer c03dfc37-08ce-4775-ac2c-c43c6ed7efd3"}
})
export const senderPepool = async({doc,id='BE0840559537',country='BE',idFacture,type=1})=>{
   // let _doc = await(readFileAsText(doc))

    let url = `/invoice?supplier=8f70d0a8-db84-4048-a9b7-0b338e6f66d4&customerid=${id}&customercountry=${country}&type=${type}`

    try{
        var {data}=axiosPeppol.post(url,doc)
        console.log(data)
    }
    catch(e){
        console.log("NOSEDN",e)
    }

}


 async function readFileAsText(file) {
    return new Promise((resolve,reject)=>{
        const reader = new FileReader();
        reader.onload=()=>resolve(reader.result)
        reader.onerror=reject
        reader.readAsText(file,'utf-8')
    })
    
}